import React, { useEffect, useState } from "react";
import BreadCrumbBanner from "../component/BreadCrumbBanner";
import aboutAPI from "../api/aboutApi";


const OurLeaders = () => {
  const [leaders, setLeaders] = useState([]);
  const [loading, setLoading] = useState(true);

  const getLayoutConfig = (index) => ({
    imageFirst: index % 2 === 0,
    imageCol: index % 2 === 0 ? "col-md-4" : "col-md-3",
    textCol: index % 2 === 0 ? "col-md-8" : "col-md-9",
  });

  useEffect(() => {
    const fetchLeaders = async () => {
      try {
        const response = await aboutAPI.leaders_api();
        if (response.code === 200) {
          setLeaders(response.data);
        }
      } catch (error) {
        console.error("Error fetching leaders:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchLeaders();
  }, []);

  return (
    <>
      <BreadCrumbBanner
        title="Our Leaders"
        backgroundImage={`${process.env.PUBLIC_URL}/assets/img/about-top2.webp`}
      />

      {loading ? (
        <div className="text-center py-5">
          <p>Loading...</p>
        </div>
      ) : (
        leaders.map((leader, index) => {
          const { imageFirst, imageCol, textCol } = getLayoutConfig(index);

          return (
            <section
              key={leader.id}
              className={`leader-section py-5 ${index % 2 === 0 ? "bg-white" : "bg-light"}`}
            >
              <div className="container">
                <div className="row align-items-center">

                  {imageFirst && (
                    <div className={`${imageCol} text-center mb-3 mb-md-0`}>
                      <img
                        src={leader.image}
                        alt={leader.title}
                        className="img-fluid"
                        loading="lazy"
                      />
                    </div>
                  )}
                  <div className={textCol}>
                    <h2 className="mrv-title">{leader.designation} -<span> {leader.name}</span></h2>

                    {leader.title && (
                      <h5 className="founder-tagline">{leader.title}</h5>
                    )}

                      
                    <p dangerouslySetInnerHTML={{ __html: leader.description }} />
                  </div>

                  {!imageFirst && (
                    <div className={`${imageCol} text-center mb-3 mb-md-0`}>
                      <img
                        src={leader.image}
                        alt={leader.title}
                        className="img-fluid"
                        loading="lazy"
                      />
                    </div>
                  )}

                </div>
              </div>
            </section>
          );
        })
      )}
    </>
  );
};

export default OurLeaders;